/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Event_Trigger_No_DatasetsInputs */



/**
* | output |
* | --- |
* | "You have no dataset you can read." |
*
* @param {Agent_Event_Trigger_No_DatasetsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_trigger_no_datasets = /** @type {((inputs?: Agent_Event_Trigger_No_DatasetsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Trigger_No_DatasetsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben keinen Datensatz, den Sie lesen können.")
	return /** @type {LocalizedString} */ ("You have no dataset you can read.")
});